<template>
  <v-card>
    <v-toolbar flat>
      <div>
        <v-toolbar-title class="text-h6 font-weight-regular">Select options and map fields to match customers</v-toolbar-title>
      </div>
    </v-toolbar>
      <v-container class="ma-0 mp-0">
        <v-form ref="matchCsvForm" autocomplete="off">
          <v-card-text>
            <v-row no-gutters>
              <v-col :cols="ui.mappingDmsWidth">
                <p class="text-subtitle-1 font-weight-medium">1) Result Options:</p>
              </v-col>
              <v-col :cols="12 - ui.mappingDmsWidth">
                <v-radio-group v-model="includeCustomerDetails" class="mp-0 ma-0">
                  <v-radio label="Include customer details in the processed results" :value="true"></v-radio>
                  <v-radio label="Only set the customer_id in the processed results" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- VIN MATCHING -->
            <v-row no-gutters>
              <v-col :cols="ui.mappingDmsWidth">
                <p class="text-subtitle-1 font-weight-medium">2) VIN Matching:</p>
               </v-col>
              <v-col :cols="12 - ui.mappingDmsWidth">
                <v-radio-group v-model="doPartialVinMatch" class="mp-0 ma-0">
                  <v-radio label="Match Full VIN" :value="false"></v-radio>
                  <v-radio label="Match Partial VIN" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <!-- MAPPING -->
            <v-row no-gutters>
              <v-col cols="12">
                <p class="text-subtitle-1 font-weight-medium">3) Specify which CSV fields should be used to map the CSV data to DMS Data</p>
                <p><span class="font-italic font-weight-bold red--text">Warning: </span><span class="font-italic font-weight-bold">Do not </span>map the same CSV Column to different DMS columns otherwise you will end up with an error or unexpected results.</p>
              </v-col>
            </v-row>

            <!-- REQUIRED MAPPINGS -->
            <v-row no-gutters>
              <v-col cols="12">
                <p class="text-subtitle-1 font-italic">Map <span class="font-weight-bold">ALL</span> of the following</p>
              </v-col>
            </v-row>
            <!-- HEADER ROW -->
            <v-row no-gutters>
              <v-col :cols="ui.mappingDmsWidth" :offset="ui.mappingColOffset">
                <span class="text-subtitle-1 font-weight-bold">Dms Field</span>
              </v-col>
              <v-col :cols="ui.mappingDmsWidth">
                <span class="text-subtitle-1 font-weight-bold">CSV Field</span>
              </v-col>
            </v-row>
            <!-- REQUIRED FIELDS -->
            <v-row no-gutters>
              <v-col :cols="ui.mappingDmsWidth" :offset="ui.mappingColOffset">
                <v-subheader>VIN</v-subheader>
              </v-col>
              <v-col :cols="ui.mappingCsvWidth">
                <v-autocomplete
                  autocomplete="off"
                  v-model="vin"
                  :items="csvColumnNames"
                  required
                  :rules="vruleFieldRequired"
                  hint="*Required"
                  persistent-hint
                >
                </v-autocomplete>
              </v-col>
            </v-row>

         </v-card-text>
        </v-form>
      </v-container>
  </v-card>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import StepHelperMixin from './StepHelperMixin'
import { mapState, mapGetters, mapActions } from 'vuex'
import { path } from 'ramda'

export default {
  name: 'match-vin-to-last-customer',
  mixins: [validationMixin, StepHelperMixin],
  data: function () {
    return {
      ui: {
        mappingDmsWidth: 2,
        mappingCsvWidth: 3,
        mappingColOffset: 1
      }
    }
  },
  computed: {
    ...mapState('CsvMappingStore', ['csvColumnNames', 'workflowSteps', 'transforms']),
    componentName () {
      return this.$options.name
    },
    mappingKey () {
      return 'mapping'
    },
    optionsKey () {
      return 'options'
    },
    vin: {
      get () {
        return path([this.mappingKey, 'vin'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, argsKey: this.mappingKey, key: 'vin', value: val })
        this.validateStep()
      }
    },
    includeCustomerDetails: {
      get () {
        return path([this.optionsKey, 'include_customer_details'], this.mappingTransformData()(this.componentName))
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, argsKey: this.optionsKey, key: 'include_customer_details', value: val })
        this.validateStep()
      }
    },
    doPartialVinMatch: {
      get () {
        const vinMatchValue = path([this.optionsKey, 'do_partial_vin_match'], this.mappingTransformData()(this.componentName))
        // this is a new field addition, default to false which was the original behavior
        if (vinMatchValue === undefined || vinMatchValue === null) {
          return false
        } else {
          return vinMatchValue
        }
      },
      set (val) {
        this.updateMappingTransformData({ componentName: this.componentName, argsKey: this.optionsKey, key: 'do_partial_vin_match', value: val })
        this.validateStep()
      }

    }
  },
  methods: {
    ...mapActions('CsvMappingStore', ['updateMappingTransformData']),
    ...mapGetters('CsvMappingStore', ['mappingTransformData']),
    validateStep () {
      this.setStepIsValid(!!this.vin)
    }
  }
}
</script>
